module.exports = __webpack_public_path__ + "static/media/kbingo.275e1452.png";